import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { confirmPasswordReset } from 'firebase/auth';
import { auth } from '../firebase/config';
import './PasswordReset.css';

const PasswordReset = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const actionCode = location.state?.actionCode;

  useEffect(() => {
    // actionCodeがない場合はエラー画面に遷移
    if (!actionCode) {
      setError('無効なパスワードリセットリンクです。');
    }
  }, [actionCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // パスワードの確認
    if (password !== confirmPassword) {
      setError('パスワードが一致しません。');
      return;
    }
    
    if (password.length < 6) {
      setError('パスワードは6文字以上で入力してください。');
      return;
    }

    setLoading(true);
    
    try {
      // Firebaseでパスワードリセットを完了
      await confirmPasswordReset(auth, actionCode, password);
      
      setSuccess(true);
      
      // 3秒後にログインページに遷移
      setTimeout(() => {
        navigate('/login');
      }, 3000);
      
    } catch (error) {
      console.error('パスワードリセットエラー:', error);
      
      switch (error.code) {
        case 'auth/expired-action-code':
          setError('リセットリンクの有効期限が切れています。新しいリセットメールをリクエストしてください。');
          break;
        case 'auth/invalid-action-code':
          setError('無効なリセットリンクです。');
          break;
        case 'auth/weak-password':
          setError('パスワードが弱すぎます。より強力なパスワードを設定してください。');
          break;
        default:
          setError('パスワードリセット処理中にエラーが発生しました。');
      }
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="password-reset-container">
        <div className="password-reset-box">
          <img src="/img/tiny-identity.png" alt="Tiny Identity" className="password-reset-logo" />
          <h1 className="password-reset-title">Tiny Identity</h1>
          
          <div className="password-reset-success-message">
            <p>パスワードが正常に変更されました。< br/>新しいパスワードでログインしてください。</p>
          </div>
          
          <button 
            className="password-reset-btn-primary" 
            onClick={() => navigate('/login')}
          >
            ログイン画面に移動
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="password-reset-container">
      <div className="password-reset-box">
        <img src="/img/tiny-identity.png" alt="Tiny Identity" className="password-reset-logo" />
        <h1 className="password-reset-title">Tiny Identity</h1>
        
        <p className="password-reset-description">
          新しいパスワードを入力してください。
        </p>

        {error && (
          <div className="password-reset-error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="password-reset-form-group">
            <label htmlFor="password">新しいパスワード</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              placeholder="6文字以上で入力してください"
            />
          </div>

          <div className="password-reset-form-group">
            <label htmlFor="confirmPassword">パスワード確認</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
              placeholder="上記と同じパスワードを入力"
            />
          </div>

          <button 
            type="submit" 
            className="password-reset-btn-primary"
            disabled={loading || !password || !confirmPassword}
          >
            {loading ? 'パスワード変更中...' : 'パスワードを変更'}
          </button>
        </form>

        <button 
          className="password-reset-btn-outline" 
          onClick={() => navigate('/login')}
          disabled={loading}
        >
          ログイン画面に戻る
        </button>
      </div>
    </div>
  );
};

export default PasswordReset;
